(function () {
  const PRODUCT_INFO_SELECTOR = 'product-info';
  const PRODUCT_FORM_SELECTOR = 'form[is="product-form"]';
  const WIDGET_ROOT_PREFIX = 'rebuy-widget-';
  let selectedVariantId = null;
  let syncTimeout = null;
  const syncedWidgetVariants = new Map();

  function getSelectedVariantId() {
    const variantInput = document.querySelector(`${PRODUCT_INFO_SELECTOR} ${PRODUCT_FORM_SELECTOR} [name="id"]`);
    return variantInput && variantInput.value ? variantInput.value : null;
  }

  function normalizeVariantId(variantId) {
    const parsedVariantId = Number.parseInt(variantId, 10);
    return Number.isNaN(parsedVariantId) ? null : parsedVariantId;
  }

  function widgetLivesOnProductInfo(widget) {
    const widgetElement = document.getElementById(`${WIDGET_ROOT_PREFIX}${widget.id}`);
    return Boolean(widgetElement && widgetElement.closest(PRODUCT_INFO_SELECTOR));
  }

  function getVariantDrivenWidgets() {
    const widgets = window.Rebuy && Array.isArray(window.Rebuy.widgets) ? window.Rebuy.widgets : [];

    return widgets.filter((widget) => {
      if (!widget || typeof widget.getWidgetProducts !== 'function' || !widget.data) {
        return false;
      }

      if (typeof widget.isCartBasedWidget === 'function' && widget.isCartBasedWidget()) {
        return false;
      }

      return widgetLivesOnProductInfo(widget);
    });
  }

  function syncWidgetsToVariant(variantId) {
    const normalizedVariantId = normalizeVariantId(variantId || selectedVariantId || getSelectedVariantId());
    if (!normalizedVariantId) return;

    selectedVariantId = String(normalizedVariantId);

    getVariantDrivenWidgets().forEach((widget) => {
      const widgetId = String(widget.id);
      const currentVariantIds = Array.isArray(widget.data.shopify_variant_ids)
        ? widget.data.shopify_variant_ids.map((id) => String(id))
        : [];

      if (
        syncedWidgetVariants.get(widgetId) === selectedVariantId &&
        currentVariantIds.length === 1 &&
        currentVariantIds[0] === selectedVariantId
      ) {
        return;
      }

      widget.data.shopify_variant_ids = [normalizedVariantId];
      syncedWidgetVariants.set(widgetId, selectedVariantId);
      widget.getWidgetProducts();
    });
  }

  function scheduleVariantSync(variantId) {
    selectedVariantId = variantId ? String(variantId) : getSelectedVariantId();
    if (!selectedVariantId) return;

    window.clearTimeout(syncTimeout);
    syncTimeout = window.setTimeout(function () {
      syncWidgetsToVariant(selectedVariantId);
    }, 60);
  }

  function refreshNativeCart(openDrawer) {
    document.dispatchEvent(
      new CustomEvent('cart:refresh', {
        bubbles: true,
        detail: openDrawer ? { open: true } : {},
      })
    );
  }

  function cartItemWasAddedByRebuy(item) {
    if (!item || typeof item !== 'object') return false;

    const items = Array.isArray(item.items) ? item.items : [item];

    return items.some((lineItem) => {
      const properties = lineItem && lineItem.properties ? lineItem.properties : {};
      return properties && (properties._source === 'Rebuy' || properties._widget_id);
    });
  }

  document.addEventListener('variant:changed', function (event) {
    const variantId = event.detail && event.detail.variant ? event.detail.variant.id : getSelectedVariantId();
    scheduleVariantSync(variantId);
  });

  document.addEventListener('rebuy.ready', function (event) {
    const widget = event.detail && event.detail.widget;
    if (widget && widgetLivesOnProductInfo(widget)) {
      scheduleVariantSync(selectedVariantId || getSelectedVariantId());
    }
  });

  document.addEventListener('rebuy.refresh', function (event) {
    const widget = event.detail && event.detail.widget;
    if (widget && widgetLivesOnProductInfo(widget)) {
      scheduleVariantSync(selectedVariantId || getSelectedVariantId());
    }
  });

  document.addEventListener('rebuy.add', function () {
    refreshNativeCart(true);
  });

  document.addEventListener('rebuy:cart.add', function (event) {
    const item = event.detail && event.detail.item ? event.detail.item : null;

    if (cartItemWasAddedByRebuy(item)) {
      refreshNativeCart(true);
    }
  });

  document.addEventListener('rebuy.change', function () {
    refreshNativeCart(false);
  });

  document.addEventListener('rebuy.remove', function () {
    refreshNativeCart(false);
  });

  document.addEventListener('DOMContentLoaded', function () {
    scheduleVariantSync(getSelectedVariantId());
    window.setTimeout(function () {
      scheduleVariantSync(getSelectedVariantId());
    }, 1200);
  });
})();